import React from 'react'
import img from "../assets/Group 3863.webp"
import Client from './Client'
import Footer from './footer'
import { Link } from 'react-router-dom'

const About = () => {
  return (
    <div id='about'>
      <div id='about-1' className='flex justify-between py-12 px-20'>

        <div id='about-sec-1' className='w-2/5'>
        <img src={img} alt='vwrap'/>
        </div>


        <div id='about-sec-2' className='w-2/4'>
          <h2 >
            WE ARE A PROMISING<br/>
            <span>360 ADVERTISEMENT </span><br/>
            AGENCY
          </h2>

          <p className='text-white my-8 pl-12'>Established with an aim to provide effective quality 360 advertisement solutions to the marketers. Vwrap is a prime platform for advertisers to maximize their return on investment as we provide you innovative and integrated brand marketing. Our sole objective is to fulfil the requirements of our clients according to their needs.</p>

          <p id='about-btn'>Learn More</p>
        </div>
      </div>



      <div id='about-2' className='flex justify-between py-12 px-20'>




<div id='about-sec-2' className='w-2/4'>
  <h2 >
    WE ARE A PROMISING<br/>
    <span>360 ADVERTISEMENT </span><br/>
    AGENCY
  </h2>

  <p className='text-white my-8 pl-12'>Established with an aim to provide effective quality 360 advertisement solutions to the marketers. Vwrap is a prime platform for advertisers to maximize their return on investment as we provide you innovative and integrated brand marketing. Our sole objective is to fulfil the requirements of our clients according to their needs.</p>

  <div className='btn-container'>
  <p id='about-btn'>Learn More</p>
  </div>
</div>

<div id='about-sec-1' className='w-2/5'>
<img src={img} alt='vwrap' />
</div>

</div>

    <div id='talk-1'></div>
    <div id="talk-sec">
      <h2>
        NEED HELP WITH ADVERTISEMENT? <span><Link to="/contact"> LET'S Talk</Link></span>
      </h2>
    </div>
    <div id='talk-2'></div>
    <br />
    <br/>
    </div>

  )
}

export default About
